window.addEventListener('DOMContentLoaded', function() {
  /* --------------- effect anime --------------- */
  setTimeout(function() {
     document.querySelector('.fade-in').classList.add('scrollin');
  }, 300);
  
  const scrollElements = document.querySelectorAll('.scroll_anime');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });

  /* --------------- swiper --------------- */
  const lvcSwiper = new Swiper('.swiper', {
      loop: true,
      effect: 'fade',
      autoplay: {
          delay: 3000,
          disableOnInteraction: false
      },
      speed: 2000,
      allowTouchMove: false
  });
});

window.addEventListener('scroll', function() {
  const scrollElements = document.querySelectorAll('.scroll_anime');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });
});

